import { metrics } from '@atlassian/browser-metrics';

export const dashboardsDirectoryPageLoad = metrics.pageLoad({
	key: 'dashboards-directory',
	ssr: {
		doneAsFmp: true,
	},
});
